<template>
  <div class="ma-2">
    <div class="tab1" v-for="data in Teams.data" :key="data.Key">
      <v-lazy
        v-model="isActive"
        :options="{
          threshold: 0.5,
        }"
        min-height="100"
        transition="fade-transition"
      >
        <v-card
          class="mt-5 shadow-none customtabsgroup"
          :id="'teamNo' + data.TeamID"
        >
          <v-tabs
            v-model="data._id"
            background-color="#C9082A"
            dark
            centered
            center-active
            class="mb-2"
          >
            <v-tabs-slider color="#17408B"></v-tabs-slider>
            <!-- tab-1 -->
            <v-tab>
              <img
                :src="data.WikipediaLogoUrl"
                height="35"
                width="35"
                class="mt-n2 mr-2"
              />
              <p>{{ data.Name }}({{ data.Key }}) Profile</p>
            </v-tab>

            <!-- tab-2 -->
            <v-tab @click.prevent="fetchDepth(data.TeamID, data.SportId)">
              <p>DEPTH CHART</p>
            </v-tab>

            <!-- tab-3 -->
            <v-tab @click.prevent="fetchInjuries(data.TeamID, data.SportId)">
              <p>
                INJURIES
                <!-- INJURIES &nbsp;({{ data.Injuries ? data.Injuries.length : '' }}) -->
              </p>
            </v-tab>

            <!-- tab-4 -->
            <v-tab
              @click.prevent="fetchUpcomingGame(data.TeamID, data.SportId)"
            >
              <p>UPCOMING GAMES</p>
            </v-tab>

            <!-- tab 5 -->
            <v-tab @click.prevent="fetchTeamNews(data.TeamID, data.SportId)">
              <p>Team News</p>
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="data._id" touchless>
            <!--  Team table start  -->
            <v-tab-item class="team-table-pro">
              <team-table
                :teams="data.TopPLayers"
                :schedule="data.Schedule"
                :homeLogo="data.HomeTeamLogo.WikipediaLogoUrl"
                :oppLogo="data.AwayTeamLogo.WikipediaLogoUrl"
                :sportsType="data.SportType"
              />
            </v-tab-item>

            <!--  Team table ends -->

            <!-- depth chart start -->
            <v-tab-item>
              <depth-chart
                :depth="depthChartData.data"
                :defaultSport="defaultSport"
              />
            </v-tab-item>
            <!-- depth chart ends -->

            <!-- Injuries chart start -->
            <v-tab-item>
              <injuries :injuries="injuriesData.data" />
            </v-tab-item>

            <!-- Injuries chart start -->
            <v-tab-item>
              <upcoming
                :upcomingGame="data.Schedule"
                :oppLogo="data.AwayTeamLogo.WikipediaLogoUrl"
                :nextGame="upcomingGamesData.data"
                :sportsType="data.SportType"
              />
            </v-tab-item>

            <!-- Team news -->
            <v-tab-item>
              <team-news />
            </v-tab-item>

            <!-- Injuries chart end -->
            <!-- <div class="ma-4">
              <router-link
                :to="{
                  name: 'TeamProfile',
                  params: { teamId: data.TeamID, SportId: data.SportId },
                }"
                style="text-decoration: none;"
                class="caption"
              >
                <v-icon>mdi-account-group-outline</v-icon>
                View Team
              </router-link>
            </div> -->
          </v-tabs-items>
        </v-card>
      </v-lazy>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import teamTable from "../Tables/teamTable";
import depthChart from "../Tables/depthChart";
import injuries from "../Tables/Injuries";
import upcoming from "../Cards/UpcomingGame";
import teamNews from "../Cards/TeamNews.vue";

export default {
  name: "statsTab",
  components: {
    teamTable,
    depthChart,
    injuries,
    upcoming,
    teamNews,
  },

  props: {
    Teams: {
      type: [Array, Object],
      default: () => [],
    },

    defaultSport: {
      type: String,
      default: "",
    },

    defaultOptimizer: {
      type: String,
      default: "",
    },

    injuriesData: {
      type: [Array, Object],
      default: () => [],
    },

    depthChartData: {
      type: [Array, Object],
      default: () => [],
    },

    upcomingGamesData: {
      type: [Array, Object],
      default: () => [],
    },
  },

  data: () => ({
    isActive: false,
  }),

  methods: {
    fetchInjuries(teamId, sportId) {
      let obj = {
        TeamID: teamId,
        SportId: sportId,
      };
      if (this.defaultSport == "1") {
        this.$store.dispatch("NbaModule/getInjuries", obj);
      } else if (this.defaultSport == "2") {
        this.$store.dispatch("MlbModule/getInjuries", obj);
      } else if (this.defaultSport == "3") {
        this.$store.dispatch("NhlModule/getInjuries", obj);
      } else if (this.defaultSport == "4") {
        this.$store.dispatch("NflModule/getInjuries", obj);
      }
    },

    fetchDepth(teamId, sportId) {
      let obj = {
        TeamID: teamId,
        SportId: sportId,
      };
      if (this.defaultSport == "1") {
        this.$store.dispatch("NbaModule/getDepth", obj);
      } else if (this.defaultSport == "2") {
        this.$store.dispatch("MlbModule/getDepth", obj);
      } else if (this.defaultSport == "3") {
        this.$store.dispatch("NhlModule/getDepth", obj);
      } else if (this.defaultSport == "4") {
        this.$store.dispatch("NflModule/getDepth", obj);
      }
    },

    fetchUpcomingGame(teamId, sportId) {
      let obj = {
        TeamID: teamId,
        SportId: sportId,
      };
      if (this.defaultSport == "1") {
        this.$store.dispatch("NbaModule/getUpcomingGames", obj);
      } else if (this.defaultSport == "2") {
        this.$store.dispatch("MlbModule/getUpcomingGames", obj);
      } else if (this.defaultSport == "3") {
        this.$store.dispatch("NhlModule/getUpcomingGames", obj);
      } else if (this.defaultSport == 4) {
        this.$store.dispatch("NflModule/getUpcomingGames", obj);
      }
    },

    fetchTeamNews(teamId, sportId) {
      let obj = {
        TeamID: teamId,
        SportId: sportId,
      };

      this.$store.dispatch("userModule/fetchTeamNews", obj);
    },
  },
};
</script>
<style scoped>
@media (max-width: 415px) {
  .team-a {
    margin-left: 20px;
  }
  .team-b {
    margin-left: 20px;
  }
}
</style>
